import React from 'react';

const styles = {
  menuContainer: {
    flexDirection: 'column',
    display: 'flex',
    marginLeft: '25%',
    marginRight: '25%'
  },
}

function ContactUs() {
  return (
    <div style={styles.menuContainer}>
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSdWfk3UvlryABpUQunio8ox6FFOQ14FP2ubEtSTDoMrDj9vMA/viewform?embedded=true"
        width="640"
        height="777"
        frameborder="0"
        marginheight="0"
        marginwidth="0">
        Contact Us
      </iframe>
    </div>
  )
}

export default ContactUs;
